module.exports = __webpack_public_path__ + "img/hj4.e9cdf0bf.jpg";